import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUp,
  faArrowDown,
  faExclamationCircle,
  faCheckSquare,
  faGift,
  faPercent,
} from '@fortawesome/free-solid-svg-icons';
import { KeyMetric } from './types';

export interface SalesData {
  grossSales?: string | number;
  tips?: string | number;
  refunds?: string | number;
  netSales?: string | number;
  orderCount?: string | number;
  tax?: string | number;
}

export interface MetricConfig {
  id: string;
  title: string;
  subTitle: string;
  icon: IconDefinition;
  color: string;
}

export const keyMetricsConfig: MetricConfig[] = [
  {
    id: 'netSales',
    title: 'Net Sales',
    subTitle: 'Total net revenue',
    icon: faArrowUp,
    color: '#48bb78',
  },
  {
    id: 'grossSales',
    title: 'Gross Sales',
    subTitle: 'Total gross revenue',
    icon: faArrowDown,
    color: '#f56565',
  },
  {
    id: 'refunds',
    title: 'Refunds',
    subTitle: 'Total refunds issued',
    icon: faExclamationCircle,
    color: '#9f7aea',
  },
  {
    id: 'orderCount',
    title: 'Order Count',
    subTitle: 'Total number of orders',
    icon: faCheckSquare,
    color: '#48bb78',
  },
  {
    id: 'tips',
    title: 'Tips',
    subTitle: 'Total Tips',
    icon: faGift,
    color: '#9f7aea',
  },
  {
    id: 'tax',
    title: 'Total Tax',
    subTitle: 'Total Tax',
    icon: faPercent,
    color: '#4299e1',
  },
];

export const getKeyMetrics = (salesData: SalesData | null): KeyMetric[] => {
  if (!salesData) {
    return getDefaultMetrics();
  }

  const grossSales = parseFloat(String(salesData.grossSales)) || 0;
  const tips = parseFloat(String(salesData.tips)) || 0;
  const refunds = parseFloat(String(salesData.refunds)) || 0;
  const netSales = parseFloat(String(salesData.netSales)) || 0;
  const orderCount = parseInt(String(salesData.orderCount)) || 0;
  const tax = salesData.tax ? parseFloat(String(salesData.tax)) : 0;

  return keyMetricsConfig.map((config) => {
    let value: string;
    
    switch (config.id) {
      case 'netSales':
        value = netSales.toFixed(2);
        break;
      case 'grossSales':
        value = grossSales.toFixed(2);
        break;
      case 'refunds':
        value = refunds.toFixed(2);
        break;
      case 'orderCount':
        value = orderCount.toString();
        break;
      case 'tips':
        value = tips.toFixed(2);
        break;
      case 'tax':
        value = tax.toFixed(2);
        break;
      default:
        value = '0.00';
    }

    return {
      ...config,
      value,
    };
  });
};

export const getDefaultMetrics = (): KeyMetric[] => {
  return keyMetricsConfig.map((config) => ({
    ...config,
    value: config.id === 'orderCount' ? '0' : '0.00',
  }));
};
